import { SelectProvider } from '@ariakit/react'
import { generatePath, useNavigate } from 'react-router'
import {
	SelectItem,
	SelectList,
	SelectPopover,
	SelectTrigger
} from '@/components/ui/select-atoms-legacy'
import { Skeleton } from '@/components/ui/skeleton'
import { formatDate } from '@/dates'
import { routes } from '@/routes.tsx'
import { useTranslation } from '@/translations/i18n'
import { useGetExperienceVettingVersions } from '../queries/use-get-experience-vetting-versions'
import { experienceVersionStatusToBadge } from '../utils.tsx'

export const ExpVettingVersionsSelect = ({
	experienceId
}: {
	experienceId: number
}) => {
	const { t } = useTranslation()
	const { data, isLoading } = useGetExperienceVettingVersions({
		experienceId
	})
	const navigate = useNavigate()

	return (
		<SelectProvider
			defaultValue={experienceId.toString()}
			setValue={(value) =>
				navigate(
					generatePath(routes.EXPERIENCE_VETTING_CRITERIA.path, {
						id: value
					})
				)
			}
		>
			{isLoading ? (
				<div className='flex items-center gap-2'>
					<div className='flex gap-2'>
						<Skeleton height={20} width={100} />
						<Skeleton height={20} width={100} />
					</div>
					<Skeleton height={14} width={14} />
				</div>
			) : (
				<SelectTrigger
					className='p-0 no-underline focus:bg-transparent focus:shadow-none focus:outline-none disabled:bg-neutral-100 [&:not(:disabled):hover]:bg-transparent [&:not(:disabled):hover]:shadow-none [&:not(:disabled):hover]:outline-none [&[aria-expanded="true"]]:bg-transparent [&[aria-expanded="true"]]:shadow-none [&[aria-expanded="true"]]:outline-none'
					displayValue={(value) => {
						const version = data?.find(
							(version) => version.id.toString() === value
						)
						const index = data?.findIndex(
							(version) => version.id.toString() === value
						)
						return (
							<div className='flex'>
								{version && index !== undefined && (
									<div className='flex items-center gap-2'>
										<h4 className='underline'>
											{t(
												'vetting:criteria.service.submission_number',
												{ value: index + 1 }
											)}
										</h4>
										{experienceVersionStatusToBadge(
											version.status
										)}
									</div>
								)}
							</div>
						)
					}}
					variant={'tertiary'}
				/>
			)}
			<SelectPopover sameWidth={false} unmountOnHide>
				<SelectList>
					{data?.map((value, index) => (
						<SelectItem key={value.id} value={value.id.toString()}>
							<div className='flex w-full justify-between gap-2'>
								<div className='flex items-center gap-2 text-sm'>
									<h4>
										{t(
											'vetting:criteria.service.submission_number',
											{ value: index + 1 }
										)}
									</h4>
									<p>{formatDate(value.createdAt, 'PP')}</p>
								</div>
								{experienceVersionStatusToBadge(value.status)}
							</div>
						</SelectItem>
					))}
				</SelectList>
			</SelectPopover>
		</SelectProvider>
	)
}
